import {useParams} from "react-router-dom";

const useGetParams = () => {
    return useParams()
};

export default useGetParams;
